import React  from "react";
import { makeStyles } from '@material-ui/core/styles';
import DateBox from 'devextreme-react/date-box';
import { SelectBox } from 'devextreme-react/select-box';
import dayjs from "dayjs";
import { TriStateCheckbox } from "./TriStateCheckBox";
import { deleteStrangeCharacters, renderDateIcon, renderDropdownIcon } from "../../commonFunctions/commonFunctions";
import { Template, TextBox, Validator } from "devextreme-react";
import { EmailRule } from "devextreme-react/validator";

const useStyles = makeStyles((theme) => ({
  notchedOutline: {
    outline: "none",
    border: "none",
  },
  extraSmall:{
    paddingTop: 7,
    paddingLeft: 9,
    paddingBottom: 8
  },
  root: {
    color: "#000",
    height: "3rem",
    boxSizing: "border-box",
    backgroundColor: "#e0e2e5",
    '&:focus': {
     backgroundColor: '#d1e4ff',
    },
    '&:hover:not(:focus)':{
      backgroundColor: '#c1c7cc'
    }
  },
  input:{
    color: "#000",
    fontWeight: 300,
    fontSize: "100%",
        backgroundColor: "#e0e2e5",
    '&:focus': {
     backgroundColor: '#d1e4ff',
    },
    '&:hover:not(:focus)':{
      backgroundColor: '#c1c7cc'
    }
  },
  label:{
    color: "#000",
    fontWeight: 300,
    "&.Mui-error":{
      color: "#000"
    }
  },
  underline:{
    '&::after':{
      transform: "none",
      transition: "none",
      borderBottom: "1px solid #000",
    },
    "&.Mui-error":{
      "&::after":{
        borderBottomColor: "#000"
      }
    } 
  },
  helperText:{
    margin: 0,
    padding: "0.25rem 2rem",
    backgroundColor: "#ffd9d9",
    color: "#000",
    fontWeight: 300,
  }
}));


function CustomInput(props){
    const {label, type, value, disabled, id, error, error_text, onChange, readOnly, size, row, maxValue = 50} = props;
    const classes = useStyles();
    let estilosDate = null;

    if(type === "date"){
       estilosDate = props.estilos ? props.estilos : "";
    }

    let valueSelect = "";
    let options = props.options === undefined || Object.keys(props.options).length === 0 ? undefined : Array.from(props.options);
    if ( type == "select" && readOnly == true && options != undefined) {
      options.map((option,index) => {
        if ( option.key == value || option.stateId == value) {
          valueSelect = option.value == undefined ? option.description : option.value;
        }
      });
    }
    return (
    <>
    {type=== "date"?
    readOnly? 
    <>
      <span span style={{fontWeight: 700}}>{label}:</span>
      <span className="dateReadOnly">{value === "" || !value ? null : dayjs(value).format(props.datetype=== "datetime"? "DD/MM/YYYY HH:mm": "DD/MM/YYYY")}</span>
    </>
    :
    <DateBox
    onValueChange={onChange}
    style={{position: estilosDate.position, width: estilosDate.width, flexGrow: 1}}
    useMaskBehavior={true}
    label={label}
    labelMode="floating"
    showClearButton
    disabled={props.disabled}
    applyButtonText="Aceptar"
    cancelButtonText="Cancelar"
    value={value}
    onOpened= {event => {
      const popUp = event.component._popup;
      popUp.option('closeOnTargetScroll', false)
      popUp.option('closeOnOutsideClick', false)
      const timebox = document.getElementsByClassName("dx-timeview-field")[0]

      //añade botón Limpiar al toolbar inferior:
     let toolBar = popUp.option('toolbarItems');

      const isAdded = toolBar.some(((e)=>e.id === "clearDateButton"))
      if (!isAdded && props.datetype === "datetime"){
          toolBar.push({
            location: 'center',
            toolbar: 'bottom',
            widget: 'dxButton',
            id: "clearDateButton",
            options: {
              text: "Limpiar",
              onClick: () => {
                props.clearField();
                popUp.option("visible", false)
              }
            }
          });
      }
      popUp.option('toolbarItems', toolBar);
 }
}
    type={props.datetype}
    displayFormat={props.datetype=== "datetime"? "dd/MM/yyyy HH:mm": "dd/MM/yyyy"}
    showDropDownButton
    dropDownButtonTemplate="calendarIcon"
    >
        <Template
            name="calendarIcon"
            render={renderDateIcon}
        />
    </DateBox>
    :
    type === "select"? readOnly? <div style={{marginLeft: "0px"}}>{valueSelect}</div> :
    <SelectBox 
    dataSource={props.options} 
    style={{flexGrow: 1}}
    value={value}
    label={label}
    labelMode="floating"
    searchEnabled
    showClearButton={!props.disableClear}
    noDataText={"Não há opções disponíveis"}
    disabled={props.disabled}
    displayExpr={props.displayExpr}
    valueExpr={props.valueExpr}
    onValueChange={onChange}
    placeholder="Selecionar"
    showDropDownButton
    dropDownButtonTemplate="dropdownIcon"
    >
        <Template
            name="dropdownIcon"
            render={renderDropdownIcon}
        />
    </SelectBox>
    :
    type==="checkbox"?
    readOnly? <><span style={{fontWeight: 700}}>{label}:</span><div>{value === "" || value=== null? "" : value? "Sí": "No"}</div></>:
    <div style={{display: "flex", alignItems: "center", columnGap: "0.5rem"}}>
      <div style={{fontWeight: 700}}>
        {label}:
      </div>
      <TriStateCheckbox
      checked={value}
      indeterminate={value === null || value === ""? true: false}
      onChange={onChange}
      styles={{marginLeft: props.marginLeft}}
      />
    </div>
    :
    readOnly?
    <><span style={{fontWeight: 700}}>{label}:</span><span>{value === 0? null : value}</span></>
    :
    <div style={{flexGrow: 1}}>
    <TextBox
      label={label}
      mode={type || "text"}
      labelMode={"floating"}
      id={id}
      disabled={disabled}
      value={value}
      onValueChange={(value)=>value.length<=maxValue && onChange(deleteStrangeCharacters(value))}
    >  
    {type == "email" &&
      <Validator>
        <EmailRule message="Formato de e-mail inválido" />
      </Validator>
    }
        
    </TextBox>
    {error && error_text &&
    <div className={classes.helperText}>{error_text}</div>
    }
    </div>
    }
    </>
    )
}

export {CustomInput}